var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "asset-5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181.29 192.25",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-s-g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-upper-note_to",
    transform: "translate(153.408318,21.841083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-upper-note_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-upper-note",
    d: "M155.6,3.39c-2-.51-3.17-.87-4.06-2.37-.1-.17-.24-.32-.38-.44-.39-.45-1-.68-1.62-.55-.91.2-1.49,1.09-1.29,2l5.55,25.78c-1.21-.39-2.55-.46-3.9-.17-1.9.41-3.68,1.49-5.02,3.04-3.08,3.57-3.04,8.67.09,11.36c1.65,1.43,3.93,1.96,6.23,1.47c1.9-.41,3.68-1.49,5.02-3.04c1.46-1.69,2.27-3.77,2.29-5.87c0-.64-.07-1.25-.2-1.84l-4.68-21.72c.76.3,1.53.5,2.23.68c2.27.58,3.91,1,5.06,3.91.31.77,1.13,1.19,1.92,1.02.09-.02.18-.05.27-.08.32-.13.59-.35.77-.61.25-.33.38-.76.33-1.21-1.01-8.73-4.5-10.3-8.61-11.35v0Z",
    transform: "translate(-153.408318,-21.841083)",
    fill: "#232625"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-lower-note_to",
    transform: "translate(165.468887,114.534225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-lower-note_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-lower-note",
    d: "M177.44,100.54c-1.53-1.38-2.41-2.24-2.5-3.98-.01-.2-.06-.39-.14-.57-.14-.58-.57-1.06-1.18-1.23-.89-.25-1.82.28-2.07,1.17l-7.02,25.42c-.89-.91-2.04-1.59-3.38-1.96-1.87-.52-3.95-.38-5.86.37-4.38,1.74-6.71,6.27-5.18,10.11.81,2.03,2.57,3.56,4.85,4.19c1.87.52,3.95.38,5.86-.37c2.07-.82,3.76-2.29,4.75-4.14.3-.56.52-1.14.67-1.73l5.91-21.42c.54.62,1.12,1.15,1.66,1.63c1.74,1.57,3,2.7,2.68,5.81-.09.83.45,1.58,1.22,1.79.09.02.18.04.28.05.35.04.68-.04.97-.19.38-.18.69-.49.85-.92c3.15-8.2.79-11.21-2.37-14.04v0Z",
    transform: "translate(-165.468887,-114.534225)",
    fill: "#232625"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-left-eye_ts",
    transform: "translate(55.340002,108.915001) scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-left-eye",
    d: "M43.59,116.84h-.8c-1.18,0-1.87-.48-1.71-1.39s.96-1.39,2.14-1.39h2.68c1.18,0,1.77.48,1.61,1.39s-.86,1.39-2.03,1.39h-.8l-2.46,13.49h13.12l3.69-18.63c.7-4.12-1.93-8.14-7.82-8.14-5.25,0-7.44,2.14-10.66,6.16L42.8,97.19c.21-1.18.96-1.87,2.14-1.87h36.79l1.45-7.82h-43.1l-4.5,25.06c-.48,2.89-1.18,4.28-4.28,4.28h-1.39L27.5,130.33h13.65l2.46-13.49Z",
    transform: "translate(-55.340002,-108.915001)",
    fill: "#232625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-right-eye_ts",
    transform: "translate(106.529991,108.915001) scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-right-eye",
    d: "M81.09,116.84l-2.41,13.49h13.65l2.46-13.49h-.8c-1.18,0-1.87-.48-1.71-1.39s.96-1.39,2.14-1.39h2.68c1.18,0,1.77.48,1.61,1.39s-.86,1.39-2.03,1.39h-.8l-2.46,13.49h13.12l3.69-18.63c.7-4.12-1.93-8.14-7.82-8.14-5.25,0-7.44,2.14-10.66,6.16L94,97.19c.21-1.18.96-1.87,2.14-1.87h36.79l1.45-7.82h-43.1l-4.5,25.06c-.48,2.89-1.18,4.28-4.28,4.28h-1.39Z",
    transform: "translate(-106.529991,-108.915001)",
    fill: "#232625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-mouth_to",
    transform: "translate(80.920008,163.334908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-mouth_ts",
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-mouth",
    d: "M126.1,148.4c-2.66-1.04-5.2-.67-5.78.83-.49,1.26.63,2.93,2.67,4.04-2,3.12-5.59,6.02-10.4,8.38-7.76,3.82-18.17,6.07-29.32,6.35-.77.02-1.57.03-2.35.03-19.26,0-36.51-6.06-42.07-14.76c2.04-1.11,3.16-2.79,2.68-4.04-.29-.73-1.06-1.22-2.18-1.36-1.08-.14-2.36.05-3.6.54-2.66,1.04-4.28,3.02-3.7,4.52.48,1.24,2.41,1.72,4.63,1.19c1.22,12.04,15.92,22.01,35.87,24.27c2.76.31,5.57.47,8.37.47c7.49,0,14.88-1.13,21.38-3.26c13.42-4.39,21.95-12.41,22.86-21.48c2.22.54,4.15.05,4.63-1.19.58-1.5-1.04-3.48-3.7-4.52Z",
    transform: "translate(-80.920008,-163.334908)",
    fill: "#232625"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-house_ts",
    transform: "translate(80.929575,97.784737) scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-house",
    d: "M81.77,3.74c-1.17-.71-1.75-.42-2.36,0v0c0,0-32.59,28.21-32.59,28.21v-17.81c0-.94-.86-1.8-1.8-1.8h-12.98c-.8.18-1.42.97-1.4,1.8v31.8c-9.41,8.15-18,15.09-28.26,24.44-2.11,2.13-3,4.86-1.91,7.08c1.09,2.21,3.67,3.27,6.74,3.2h9.05v109.8c0,.94.86,1.8,1.8,1.8h125.86c.94,0,1.8-.86,1.8-1.8v-109.8h10c3.13,0,4.85-1.36,6.07-3.76.39-2.37-.98-4.5-2.98-6.52-25.66-22.22-51.36-44.43-77.04-66.64ZM34.24,15.93h8.99v19.1l-8.99,7.75v-26.84ZM142.12,188.65h-122.27v-108h122.26v108Zm13.59-111.6h-148.5c-2.25.06-3.23-.72-3.48-1.24.26-1.73.15-1.83,1.18-2.92L80.59,7.51l75.62,65.4c1.58,1.6,2.02,3.04,1.97,3.37-.43.77-1.74.69-2.47.79Z",
    transform: "translate(-80.929575,-97.784737)",
    fill: "#232625"
  })), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-window_ts",
    transform: "translate(80.924976,46.484999) scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-window",
    d: "M80.95,30.34c-6.61,0-13.15,4.87-13.22,11.7l-.05,19.09c-.02.78.68,1.51,1.47,1.51h23.5c.77,0,1.47-.7,1.47-1.47l.05-19.09c.06-7.17-6.98-11.66-13.22-11.75Zm-1.79,3.14v10.08h-8.49c.14-6.33,4.56-9.31,8.49-10.08Zm.32,26.23h-8.86l.05-13.22h8.81v13.22Zm11.7,0h-8.77v-13.22h8.81l-.05,13.22ZM82.41,43.56v-10.18c4.3.58,8.89,3.87,8.81,10.18h-8.81Z",
    transform: "translate(-80.924976,-46.484999)",
    fill: "#232625"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "asset-5-s-polygon1",
    points: "80.94,30.34 80.95,30.34 80.95,30.34 80.94,30.34",
    fill: "#232625"
  }), /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-nose_to",
    transform: "translate(63.489887,145.59214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asset-5-u-nose_tr",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "asset-5-u-nose",
    d: "M62.47,143.15c1.23-.26,2.6.05,3.78.87c1.17.81,1.95,1.99,2.13,3.23.13.9.97,1.53,1.87,1.39.9-.13,1.52-.97,1.39-1.87-.31-2.14-1.6-4.13-3.51-5.46-1.92-1.33-4.23-1.84-6.35-1.38-2.11.46-4.02,1.86-5.22,3.87-1.2,2-1.55,4.34-.95,6.42.21.72.87,1.2,1.58,1.2.15,0,.3-.02.45-.06.88-.25,1.38-1.16,1.13-2.04-.34-1.21-.12-2.6.61-3.83s1.86-2.08,3.09-2.34Z",
    transform: "translate(-63.489887,-145.59214)",
    fill: "#232625"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimated);
export default __webpack_public_path__ + "static/media/animated.29d9f9c0284135bdf4537fe27ebf1bf2.svg";
export { ForwardRef as ReactComponent };